//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useCallback, useEffect, useContext } from "react";
import { useLocation, useHistory } from "react-router-dom";

// custom pages
import { styles } from "./styles";
// import { ImportDataHeader } from "./Headers/headers";
import Context from "context/context";

// material-ui
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import Button from "@material-ui/core/Button";
import { useTranslation } from 'react-i18next';
import { CSVLink } from 'react-csv';
import { exportHeaders } from "./export";
import * as moment from "moment";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import CloseIcon from "@material-ui/icons/Close";

export default function SignatureStatus() {
  const { state, dispatch } = useContext(Context);
  const location = useLocation();
  const history = useHistory();
  const classes = styles();
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [exportData, setExportData] = useState([]);
  const { t, i18n } = useTranslation()
  
  let ImportDataHeader = [];
  let ImportDataHeaderExport = [];

 
  
  let data = {};
  if (location.state?.type) {
    
    data = location.state?.data;
    ImportDataHeader =data?.ImportDataHeader || [];
    ImportDataHeaderExport = data?.headers || [];
  }
 
  let obj = {};

  console.log(location.state?.obj?.ImportDataHeader)

if (location.state?.obj) {
  obj = location.state?.obj;
  ImportDataHeader = obj?.ImportDataHeader || [];
  ImportDataHeaderExport = obj?.headers || [];
}


  if(!location.state){
    history.goBack();
  }
//   console.log
let selectedColumns = ImportDataHeaderExport.map((header) => header.label);
console.log(selectedColumns,"selectedColumns")

  const [states, setstates] = useState({
    columns: [],
    currentYear: "",
    dialog: false,
    data: [],
    selectedFields: [],
    loading: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // change pagination func
  const handlePagination = (value) => {
    setOffset(value);
  };

  useEffect(() => {
    let data = [];
    ImportDataHeaderExport.map((header, i) => {
      if (selectedColumns?.includes(header.label)) {
        data = [...data, header.key];
        return;
      }
    });
    setCount(obj?.data?.invalidData?.length );
    setStates({ selectedFields: data });
  }, []);

  let combinedData=[]
  if(obj?.data?.invalidData){
   combinedData = [...combinedData,...obj?.data?.invalidData];
  }
  if(obj?.data?.successData){
    combinedData = [...combinedData,...obj?.data?.successData];

  }

  let failedDatavalue=[]
  if(obj?.data?.invalidData){
    failedDatavalue = [...failedDatavalue,...obj?.data?.invalidData];
    // setExportData(failedDatavalue);
   }

   



  let sucesscDatavalue=[]
  if(data?.successData){
    sucesscDatavalue = [...sucesscDatavalue,...data?.successData];
    // setExportData(sucesscDatavalue);
   }

const handleExport = async () => {

  if(sucesscDatavalue.length>0){
    setExportData(sucesscDatavalue);

  }
  if (failedDatavalue.length>0){
     setExportData(failedDatavalue);

  }

  if(combinedData.length>0){
    setExportData(combinedData);


  }



  // setExportData(failedDatavalue);
 
   dispatch({ type: "SET_LOADING", payload: true });
      
        dispatch({ type: "SET_LOADING", payload: false });
       return true;
     
    }

   


   return (
    <div>
     <Button className={classes.backBtn} onClick={() => history.goBack()}>
        Back
      </Button>
      {ImportDataHeaderExport.length > 0 && (
    <>
      <CSVLink
        id="csv"
        data={exportData}
        headers={ImportDataHeaderExport}
        filename={`Signature-Record ${moment(new Date()).format("MM-DD-YYYY,h:mm A")}.csv`}
        className={classes.CSVlink}
      />
      <button
        className={classes.exportBtn1}
        onClick={async () => {
          let res = await handleExport();
          if (res) document.getElementById("csv").click();
        }}
      >
        {t("Export")}
      </button>

      {/* ✅ Show congratulation if only success */}
      {data?.successData?.length > 0 && (
        <Grid item xs={12} className={classes.contentGrid}>
          <div className={classes.content1}>
            <CheckCircleOutlineIcon className={classes.checkIcon} />
            &nbsp; {t("Congratulations!")}
          </div>
          {/* <div className={classes.content2}>
            <pre>{obj?.successCount + " " + data?.type}</pre>
          </div> */}
        </Grid>
      )}

      {/* ✅ Show record summary if both success and invalid exist */}
      {obj?.data?.successData?.length > 0 && obj?.data?.invalidData?.length > 0 && (
        <Grid item xs={12} className={classes.contentGrid}>
          <div className={classes.content2}>
            No of upload records : {obj?.uploadedCount}
            <br />
            No of success records : {obj?.successCount}
            <br />
            No of failed records : {obj?.invalidCount}
          </div>
        </Grid>
      )}

      {/* ❌ Success is empty but failed exists — red warning */}
      {obj?.data?.successData?.length === 0 && obj?.data?.invalidData?.length > 0 && (
        <Grid item xs={12} className={classes.contentGrid}>
          <div className={classes.content1Failed}>
            <CloseIcon className={classes.checkIconfailed} />
            &nbsp; Failed to upload data
          </div>
          {/* <div className={classes.content2}>
            <pre>{obj?.invalidCount + " " + data?.type}</pre>
          </div> */}
        </Grid>
      )}

      {/* ✅ Show table in all valid cases */}
      {(combinedData?.length > 0 || sucesscDatavalue?.length>0 ||failedDatavalue?.length>0) && (
        <>
          <div>Records Status :</div>
          <TableContainer className={classes.tableContainer}>
            <Table className={classes.table} size={"medium"}>
              <TableHead style={{ background: "#EDEDED" }}>
                <TableRow>
                  {selectedColumns?.map((h, i) => (
                    <TableCell key={i} className={classes.tableHeading}>
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
              {((combinedData?.length > 0
    ? combinedData
    : sucesscDatavalue?.length > 0
    ? sucesscDatavalue
    : failedDatavalue
  )).slice((offset - 1) * 10, offset * 10).map((p, i) => (
  <TableRow key={i}>
    {states.selectedFields.map((s) => (
      <TableCell
        key={`${s}-${i}`}
        align="left"
        className={classes.rowCell}
      >
        {p?.[s]}
      </TableCell>
    ))}
  </TableRow>
))}
              </TableBody>
            </Table>
          </TableContainer>

          <Pagination
            className={classes.pagination}
            variant="outlined"
            shape="rounded"
            count={Math.ceil(count / 10)}
            page={offset}
            onChange={(event, value) => handlePagination(value)}
          />
        </>
      )}
    </>
  )}
    </div>
  );
}
